<template>
  <!-- 我的订单 -->
  <div id="myOrder">
    <!-- <close-button></close-button> -->
    <div class="title">
      <van-icon size="20" name="arrow-left" @click="$router.back()" />
      <span style="color:#333; margin-left:35%; font-size:16px">我的订单</span>
    </div>
    <div class="privilege">
      <div class="orderList" v-for="item in myOrderLists" :key="item.orderid">
        <van-cell class="first-cell" title="订单编号" :value="item.orderid" />
        <van-cell title="订单明细" :value="item.product_desc" />
        <van-cell v-if="item.actualamount == 0" title="实付金额"  value="0"/>
        <van-cell v-else title="实付金额"  value="￥" >
           <template  #right-icon>
            {{item.actualamount | toDecimal}}
          </template>
        </van-cell>
        <van-cell title="下单时间" :value="moment(item.ordertime).format('YYYY-MM-DD HH:mm:ss')" />
        
         <van-cell v-if="item.paytype === 30 || item.paytype === 31 || item.paytype === 32" title="支付方式" value="微信" />
         <van-cell v-if="item.paytype === 50" title="线下支付" :value="1" />
         <van-cell v-else-if="item.paytype === 60" title="企服平台在线支付" :value="1" />
         <van-cell v-else title="支付方式" value="支付宝" />
         <van-cell title="支付结果" :value="item.paystatusdesc" />
      </div>
      <div v-if="this.myOrderLists === null" class="orderList">
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script>
import CloseButton from "@/components/common/closebutton";
export default {
  data() {
    return {
      show: false,
      myOrderLists: [], // 我的订单
    };
  },
  components: {
    CloseButton,
  },
  created() {
    this.getMyOrderPay();
  },
  methods: {
    // 获取订单列表
    getMyOrderPay() {
      this.$http
        .reqGetOrderLists()
        .then((res) => {
          console.log("获取订单列表res===>", res.items); // {{["已开户", "待审核"][scope.row.status]}}
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.myOrderLists = res.items;
            }
          }
        })
        .catch((err) => {
          console.log("myorder=====>", err);
          // this.$toast({
          //   duration: 5000,
          //   message: "服务器开小差啦,请刷新后重试!",
          // });
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
#myOrder {
  background-color:#F6F6F6;
  min-height: 100%;
  /deep/.van-cell__title {
    color: #000;
    font-weight: 500;
  }
  /deep/.van-cell__value {
    color: #404040;
  }
  .first-cell {
    .van-cell__titel {
      flex: 1;
    }
    .van-cell__value {
      flex: 2;
    }
  }
  .title {
    padding: 10px 0;
    background-color: #fff;
    border-top: 1px solid #ddd;
    display: flex;
    align-items: center;
  }
  .privilege {
    font-size: 0.37333rem;
    box-sizing: border-box;
    margin-top: 10px;
    .orderList {
      background-color: #fff;
      margin-bottom: 10px;
      box-sizing: border-box;
      .listItem {
        display: flex;
        align-items: stretch;
        margin: 6px;
        .leftWord {
          flex: 0 0 82px;
        }
        .rightWord {
          flex: 1;
          display: flex;
          align-items: flex-end;
        }
      }
    }
  }
}
</style>
